import { render, staticRenderFns } from "./ActionsTabbedView.vue?vue&type=template&id=060d6d2e&scoped=true"
import script from "./ActionsTabbedView.vue?vue&type=script&lang=js"
export * from "./ActionsTabbedView.vue?vue&type=script&lang=js"
import style0 from "./ActionsTabbedView.vue?vue&type=style&index=0&id=060d6d2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060d6d2e",
  null
  
)

export default component.exports